import { styled } from "styled-components";

export const MobileNoInputContainer = styled.div`
  .country_container {
    /* white-space: nowrap; */
    position: absolute;
    /* width: 7rem; */
    padding: 0 1.6rem 0 0.5rem;
    text-align: center;
    cursor: pointer;
    .img_flag {
      width: 1.34em;
      height: 1em;
    }
  }
  .country_container::after {
    transform: translateY(-50%) rotate(225deg);
  }
  .country_container::after {
    position: absolute;
    content: "";
    right: 0.8rem;
    top: 45%;
    transform: translateY(-50%) rotate(45deg);
    width: 0.3rem;
    height: 0.3rem;
    border-right: 0.12rem solid #111;
    border-bottom: 0.12rem solid #111;
    transition: 0.2s;
  }
  .country_dropdown {
    position: absolute;
    top: 40px;
    left: 0;
    z-index: 1;
  }
  .mobile_no_input {
    border-radius: 16px;
    border: 1px solid #e5e7ef;
    width: 200px;
    height: 30px;
    box-shadow: 0px 1px 2px 0px rgba(5, 32, 58, 0.1);
    padding: 3px 11px 3px 70px;
    background: #fcfcfc;
    font-size: 0.875rem;
    font-weight: 400;
    color: #8f8ba3;
    @media (max-width: 575.98px) {
      width: 100%;
    }
  }
  .mobile_no_input:focus {
    border: 1px solid #00a4e5 !important;
    outline: none;
  }
`;
